import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import { useGetValue } from '@alfa-bank/site-form-utils/hooks/use-get-value';

import type { TFormProgressBarV2 } from './models';
import { useProgress } from './hooks/use-progress';

export const FormProgressBarV2: FC<PropsWithChildren<TFormProgressBarV2>> = ({
    ProgressBar,
    backgroundColor,
    callToActionFinalText,
    callToActionText,
    caption,
    captionText: initCaptionText,
    children,
    className,
    currentStepName: initCurrentStepName,
    dataTestId,
    hatchValue = 0,
    header,
    inverted,
    line,
    maxStep,
    name = '',
    nextStepName,
    slogan = '',
    step: initStep,
    steps,
    value: initValue = 0,
    view,
}) => {
    const getValue = useGetValue();

    const { placeholder, progressBarValue, value } = useProgress(initValue || getValue(name));
    const step = initStep || getValue(name);

    const currentStepName =
        initCurrentStepName || slogan.replace('#param#', `${hatchValue - initValue}%`);

    const captionText =
        initCaptionText ||
        (hatchValue === value
            ? callToActionFinalText
            : `${progressBarValue}% ${callToActionText} ${placeholder}`);

    return (
        <ProgressBar
            backgroundColor={backgroundColor}
            caption={caption}
            captionText={captionText}
            className={className}
            currentStepName={currentStepName}
            dataTestId={dataTestId}
            hatchValue={hatchValue}
            header={header}
            inverted={inverted}
            line={line}
            maxStep={maxStep}
            nextStepName={nextStepName}
            step={step}
            steps={steps}
            value={value}
            view={view}
        >
            {children}
        </ProgressBar>
    );
};
